import React from 'react';
import { FieldInput, FieldInputProps } from '@spotify-internal/anchor-ds';
import { FieldController, HookFormProps } from 'client/shared/FieldController';

type ControlledFieldInputProps = Omit<FieldInputProps, 'isShowingError'> &
  HookFormProps;

export const ControlledFieldInput = (props: ControlledFieldInputProps) => (
  <FieldController<FieldInputProps, HTMLInputElement>
    as={FieldInput}
    {...props}
  />
);
